import Alpine from 'alpinejs'
Alpine.data('donationForm', (pricePerTree) => ({
    treeCount: 1,
    sub_project: null,
    presets: [1, 5, 10, 25],

    get amount() {
        return (this.treeCount * pricePerTree).toFixed(2).replace('.', ',')
    },
    get amountPaypal() {
        return (this.treeCount * pricePerTree).toFixed(2)
    },
    get selectedPreset() {
        return this.presets.includes(this.treeCount) ? this.treeCount : null
    },
    get co2Impact() {
        return this.treeCount * 10
    },
    get forestArea() {
        return this.treeCount * 20
    },
    get treeSingularPlural() {
        return this.treeCount === 1 ? 'Baum' : 'Bäume'
    },
    selectPreset(value) {
        this.treeCount = value
    },
    increment() {
        this.treeCount++
    },
    decrement() {
        if (this.treeCount > 1) this.treeCount--
    },
    setCount(value) {
        const parsed = parseInt(value, 10)
        if (!isNaN(parsed) && parsed >= 1) {
            this.treeCount = parsed
        } else {
            this.treeCount = 1
        }
    },
}))
